import React, {useEffect, useState, useRef, useContext} from 'react';
import { Container, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import classes from './Disponibilidad.module.css';
import GlobalContext from '../../../context/GlobalContext';
import {getAvailabilityPerMentor, createAvailabilityPerMentor, deleteAvailabilityPerMentor, updateAvailabilityPerMentor} from '../../../helpers/Availability.helper';

const Disponibilidad = () => {

    const [modalToggle, setModalToggle] = useState(false);
    const dias = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];
    const [isHidden, setIsHidden] = useState(true);
    const [isEditable, setIsEditable] = useState(false);
    const [dia, setDia] = useState(1);
    const [horaInicial, setHoraInicial] = useState();
    const [horaFinal, setHoraFinal] = useState();
    const [availability, setAvailability] = useState([]);
    const [idDisponibilidad, setIDisponibilidad] = useState('');
    const [modalHeader, setModalHeader] = useState('');
    const [modalBody, setModalBody] = useState('');

    const {setLoading} = useContext(GlobalContext);

    const refDia = useRef();
    const refHoraInicial = useRef();
    const refHoraFinal = useRef();


    useEffect(()=>{
        setLoading(true);
        getAvailabilityPerMentor().then(a => {
            setAvailability(a);
            setLoading(false);
        });
    },[]);

    useEffect(()=>{
        const row = document.getElementById('row0');
        if(row != undefined){
            setTimeout(()=>{
                row.scrollLeft = 1000;

                setTimeout(()=>{
                    row.scrollLeft = 0;
                }, 1500);
            }, 2000);
        }
    }, [availability])

    useEffect(()=>{
        let button = document.querySelector('.'+classes.buttonAddDisp);
        if(button){
            if(horaInicial && horaFinal){
                button.style.backgroundColor = "#0DB04B";
                button.removeAttribute('disabled');
            }else{
                button.setAttribute('disabled', true);
                button.style.backgroundColor = "#A0A4A8";
            }
        }
    }, [dia, horaInicial, horaFinal, isHidden])

    const handleClick = (e) => {
        e.preventDefault();

        var time_start = new Date();
        var time_end = new Date();
        var value_start = horaInicial.split(':');
        var value_end = horaFinal.split(':');

        time_start.setHours(value_start[0], value_start[1])
        time_end.setHours(value_end[0], value_end[1])

        var time = (time_end - time_start) / 1000;

        if(time < 1800){
            showModal(
                "Horario incorrecto",
                "La hora final debe ser por lo menos 30 minutos después de la hora inicial."
            );
            return;
        }

        setLoading(true);
        if(!isEditable){
            createAvailabilityPerMentor({
                day: Number.parseInt(dia),
                initHour: horaInicial,
                finalHour: horaFinal
            }).then(() => getAvailabilityPerMentor().then((a) => setAvailability(a)).then(()=>{
                clearData();
                setLoading(false);
            }));
        }else {
            updateAvailabilityPerMentor({
                availabilityId: idDisponibilidad,
                day: dia,
                initHour: horaInicial,
                finalHour: horaFinal
            }).then(() => getAvailabilityPerMentor().then((a) => setAvailability(a)).then(()=>{
                clearData();
                setLoading(false);
            }));
        }

    }

    const clearData = () => {
        setIsHidden(true);
        setDia(1);
        setIsEditable(false);
        setHoraInicial('');
        setHoraFinal('');
        setIDisponibilidad('');
    }

    const handleEdit = item => {
        setIsHidden(false);
        setIsEditable(true);
        setDia(item.iDia);
        setHoraInicial(item.sHoraInicio);
        setHoraFinal(item.sHoraFinal);
        setIDisponibilidad(item.idDisponibilidad);
    }

    const onDelete = (id) => {
        setLoading(true);
        deleteAvailabilityPerMentor(id).then(() => getAvailabilityPerMentor().then((a) => {setAvailability(a); setLoading(false);}));
    }

    const handleChange = (element, setValue) => {
        const value = element.current.value;
        setValue(value);
    }

    const showModal = (header, body) => {
        setModalHeader(header);
        setModalBody(body);
        setModalToggle(true);
    }

    return(
        <>
        <Container>
            <Row>
                <Col className="title-container">
                    <div>
                        <h1>Mi disponibilidad</h1>
                        <span>Agrega tu disponibilidad en formato de 24Hrs</span>
                    </div>
                </Col>
            </Row>
        </Container>
        {
            (isHidden)?
            <Container>
                <Row>
                    <Col>
                        <div className={classes.addDispContainer}>
                            <button className={classes.button} onClick={()=>setIsHidden(false)}>+ Agregar disponibilidad</button>
                        </div>

                        <Container className={classes.table}>
                            <Row className={classes.thead}>
                                <Col md="3"><span>Día</span></Col>
                                <Col md="3"><span>Hora inicial</span></Col>
                                <Col md="3"><span>Hora Final</span></Col>
                            </Row>
                            {
                                availability.map((item, index) => (
                                    <Row id={"row" + index} className={classes.tbody} key={item.idDisponibilidad}>
                                        <Col md="3"><span>{dias[item.iDia - 1]}</span></Col>
                                        <Col md="3"><span>{item.sHoraInicio}</span></Col>
                                        <Col md="3"><span>{item.sHoraFinal}</span></Col>
                                        <Col className={classes.buttons}>
                                            <span onClick={()=> {handleEdit(item)}}>Editar</span>
                                            |
                                            <span onClick={() => onDelete(item.idDisponibilidad)}>Eliminar</span>
                                        </Col>
                                    </Row>
                                ))
                            }
                        </Container>
                    </Col>
                </Row>
            </Container>
            :
            <Container style={{marginBottom: '50px'}}>
                <Row>
                    <Col>
                        <span>Ejemplo 1: </span><p>Si deseas apoyar de 9 a 10 AM, únicamente introduce 9 en hora inicial y 10 en hora final</p>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <form>
                            <div className={classes.inputContainer}>
                                <label className={classes.text} htmlFor="dias">Día de la semana</label>
                                <select id="dias" className={classes.input} defaultValue={dia} onChange={()=>{handleChange(refDia, setDia)}} ref={refDia}>
                                    {
                                        dias.map((item, index)=>(
                                            <option value={index + 1} key={item}>{item}</option>
                                        ))
                                    }
                                </select>
                            </div>

                            <div className={classes.inputContainer}>
                                <label className={classes.text} htmlFor="hora-inicial">Hora inicial</label>
                                <input type="time" id="hora-inicial" className={classes.input} min="06:00" max="22:00" defaultValue={horaInicial} onChange={()=>{handleChange(refHoraInicial, setHoraInicial)}} ref={refHoraInicial}/>
                            </div>

                            <div className={classes.inputContainer}>
                                <label className={classes.text} htmlFor="hora-final">Hora Final</label>
                                <input type="time" id="hora-final" className={classes.input} min="07:00" max="23:00" defaultValue={horaFinal} onChange={()=>{handleChange(refHoraFinal, setHoraFinal)}} ref={refHoraFinal}/>
                            </div>

                            <div className={classes.saveButtons}>
                                <input type="submit" className={classes.buttonAddDisp} value={isEditable ? "Editar disponibilidad" : "Agregar disponibilidad"} onClick={handleClick}/>
                                <span className={classes.regresar} onClick={()=>{clearData()}}>Regresar a la lista</span>
                            </div>
                        </form>
                    </Col>
                </Row>
            </Container>
        }

            {/* MODAL */}
            <div>
                <Modal size="lg" isOpen={modalToggle} >
                    <ModalHeader toggle={() => { setModalToggle(!modalToggle) }}>{modalHeader}</ModalHeader>
                    <ModalBody dangerouslySetInnerHTML={{ __html: modalBody }}></ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={() => { setModalToggle(!modalToggle) }} >
                            Aceptar
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        </>
    )
}
export default Disponibilidad;
